import { skipToken, useQuery } from '@apollo/client/react';
import ChatAPI from '../../chat/api';
import CHAT_SETTINGS from '../../queries/GetPersistedChatSettings';

export default (
  partnerId = ChatAPI.storeRetrievePartnerId(),
  category = ChatAPI.storeRetrieveCategoryParameter() || undefined,
  locale = ChatAPI.storeRetrieveLocaleParameter() || undefined,
  token = ChatAPI.storeRetrieveToken() || undefined,
) => {
  const { data, loading } = useQuery(
    CHAT_SETTINGS,
    partnerId
      ? {
          variables: {
            id: partnerId,
            locale,
            category,
            token,
          },
        }
      : skipToken,
  );
  return { data, loading };
};
